import { Application } from 'pixi.js';
import { WORLD_W, WORLD_H } from './render/theme.js';

export interface ScreenInfo {
  scale: number;
  offsetX: number;
  offsetY: number;
  canvasW: number;
  canvasH: number;
}

export class PixiApp {
  readonly app: Application;
  private screenInfo: ScreenInfo = { scale: 1, offsetX: 0, offsetY: 0, canvasW: 0, canvasH: 0 };

  constructor() {
    this.app = new Application();
  }

  async init(): Promise<void> {
    await this.app.init({
      resolution: window.devicePixelRatio || 1,
      autoDensity: true,
      antialias: false,
      backgroundAlpha: 1,
      background: 0x050810,
      resizeTo: window,
    });

    const container = document.getElementById('app');
    if (!container) throw new Error('#app element not found');
    container.appendChild(this.app.canvas);

    // Force canvas to fill the container
    const canvas = this.app.canvas as HTMLCanvasElement;
    canvas.style.display = 'block';
    canvas.style.touchAction = 'none';

    this.resize();
    window.addEventListener('resize', this.resize);
  }

  getScreenInfo(): ScreenInfo {
    return this.screenInfo;
  }

  private resize = (): void => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    const scaleX = w / WORLD_W;
    const scaleY = h / WORLD_H;
    const scale = Math.min(scaleX, scaleY);

    const scaledW = WORLD_W * scale;
    const scaledH = WORLD_H * scale;
    const offsetX = (w - scaledW) / 2;
    const offsetY = (h - scaledH) / 2;

    this.screenInfo = { scale, offsetX, offsetY, canvasW: w, canvasH: h };

    // Scale and center the stage
    this.app.stage.scale.set(scale);
    this.app.stage.x = offsetX;
    this.app.stage.y = offsetY;
  };

  destroy(): void {
    window.removeEventListener('resize', this.resize);
    this.app.destroy(true);
  }
}
